import { deviceManager } from '../../device/device_manager'
import { dataProfileManage } from '../../snapshot/profile'

export const handleSetReset = async () => {
  dataProfileManage().ResetData()

  await deviceManager.deviceDriver.reset()
}
